import { useEffect } from 'react'
import NextImage from 'next/image'
import cn from 'classnames'
import { useTranslation, Trans } from '@mc/i18n'
import { cloudflareLoader } from '@mc/image-cloudflare'
import { InterstitialStep } from 'pages/find-my-classes/components/Quiz/components/InterstitialStep'
import { updateQueryParam } from 'pages/find-my-classes/components/Quiz/utils'
import PartnerLogos from '../../assets/icons.svg'
import { CERTS_PARAM, CERTS_VALUES } from '../../getServerSideCertsParam'
import { CERTS_QUIZ_PLANS_I18N_NAMESPACE } from '../../i18n'
import classes from './CertsInterstitial.module.scss'

const CERTIFICATES_IMAGE_URL =
  'https://static.masterclass.com/prcng-1138_certificate.jpg'

export const CertsInterstitial = () => {
  const { t } = useTranslation(CERTS_QUIZ_PLANS_I18N_NAMESPACE)

  // Reaching this screen is the signal the plans page reads, so the param is
  // written on view rather than on Next: `updateQueryParam` uses replaceState,
  // so it survives the hop to the results page and on into checkout.
  useEffect(() => {
    updateQueryParam(CERTS_PARAM, CERTS_VALUES.quiz)
  }, [])

  return (
    <InterstitialStep
      className='col-12 col-md-8 col-lg-7'
      title={
        <Trans
          i18nKey='certsInterstitial.title'
          ns={CERTS_QUIZ_PLANS_I18N_NAMESPACE}
          components={{
            highlight: <span className='mc-text-color--primary' />,
            br: <br />,
          }}
        />
      }
    >
      <div
        className={cn(
          classes.card,
          'd-flex flex-column align-items-center mc-p-4 mc-gap-4 mc-mx-auto',
          'mc-corners--lg',
        )}
      >
        <p
          className={cn(
            classes.subtitle,
            'mc-text-small mc-text--center mc-mb-0 mc-w-100',
          )}
        >
          <Trans
            i18nKey='certsInterstitial.subtitle'
            ns={CERTS_QUIZ_PLANS_I18N_NAMESPACE}
            components={{
              br: <br />,
            }}
          />
        </p>
        <div
          className={cn(classes.imageContainer, 'position-relative mc-w-100')}
        >
          <NextImage
            alt={t('certsInterstitial.heroAlt')}
            loader={cloudflareLoader}
            src={CERTIFICATES_IMAGE_URL}
            className='mc-w-100 mc-h-100 mc-corners--lg'
            fill
            sizes='(max-width: 520px) 75vw, 384px'
            style={{ objectFit: 'cover' }}
          />
        </div>
        <div className='d-flex flex-column align-items-center mc-gap-2 mc-w-100'>
          <p
            className={cn(
              classes.label,
              'mc-text-small mc-text--center mc-mb-0',
            )}
          >
            {t('certsInterstitial.partnership')}
          </p>
          <PartnerLogos
            aria-label={t('certsInterstitial.partnersAlt')}
            role='img'
            className={classes.partnerLogos}
          />
        </div>
      </div>
    </InterstitialStep>
  )
}
